module.exports = __webpack_public_path__ + "img/custom.8ff2ce6.png";